import { PureComponent } from 'react'
import PropTypes from 'prop-types'

class ModalController extends PureComponent {
  static propTypes = {
    children: PropTypes.func.isRequired
  }

  state = { opened: false }
  mounted = false

  componentDidMount() {
    this.mounted = true
  }

  componentWillUnmount() {
    this.mounted = false
  }

  showModal = () => {
    if (this.mounted) this.setState({ opened: true })
  }

  hideModal = () => {
    if (this.mounted) this.setState({ opened: false })
  }

  getStateAndHelpers = () => ({
    opened: this.state.opened,
    showModal: this.showModal,
    hideModal: this.hideModal
  })

  render() {
    return this.props.children(this.getStateAndHelpers())
  }
}

export default ModalController
